import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackCanvasNextActionPillsShown.meta';

export type UseTrackCanvasNextActionPillsShownParams = {
  canvas_id: string;
  pill_ids: Array<'animate' | 'remove_background' | 'change_lighting' | 'stylize'>;
};

export const useTrackCanvasNextActionPillsShown = () => {
  const { track } = useAnalyticsUtilities();

  const trackCanvasNextActionPillsShown = useCallback(
    (params: UseTrackCanvasNextActionPillsShownParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCanvasNextActionPillsShown };
};
